import React from 'react';
import { Link } from 'react-router-dom';

export default function DockclawLogo({ className = '' }) {
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`}>
      <img src="/dlogoblack.svg" alt="DockClaw" className="h-9 w-auto" />
    </Link>
  );
}
